// Calculate and display post number as Roman numeral on article pages
// Stores post positions from feed pages and retrieves on article pages

const STORAGE_KEY = 'proteus-post-positions';

function toRoman(num) {
    const romanNumerals = [
        ['m', 1000], ['cm', 900], ['d', 500], ['cd', 400],
        ['c', 100], ['xc', 90], ['l', 50], ['xl', 40],
        ['x', 10], ['ix', 9], ['v', 5], ['iv', 4], ['i', 1]
    ];
    let result = '';
    for (const [letter, value] of romanNumerals) {
        while (num >= value) {
            result += letter;
            num -= value;
        }
    }
    return result;
}

function storePostPositions() {
    // On feed pages, store all post positions
    const postItems = document.querySelectorAll('.proteus-post-item');
    if (postItems.length === 0) return;

    const totalPosts = postItems.length;
    const positions = {};
    postItems.forEach((item, index) => {
        const link = item.querySelector('a[href]');
        if (link) {
            const url = new URL(link.href).pathname;
            // Use reverse numbering: newest (index 0) gets highest number
            positions[url] = totalPosts - index;
        }
    });

    // Merge with existing positions
    try {
        const existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
        const merged = { ...existing, ...positions };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    } catch (e) {
        // Storage not available
    }
}

function setArticleNumber() {
    const numberEl = document.querySelector('.proteus-article-number');
    if (!numberEl) return;

    const currentPath = window.location.pathname;

    try {
        const positions = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
        const position = positions[currentPath];

        if (position) {
            numberEl.textContent = toRoman(position).toUpperCase();
        } else {
            numberEl.style.display = 'none';
        }
    } catch (e) {
        numberEl.style.display = 'none';
    }
}

export default function postNumber() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            storePostPositions();
            setArticleNumber();
        });
    } else {
        storePostPositions();
        setArticleNumber();
    }
}
